export const COLUMNS = (handleStatusToggle) => [
  {
    Header: "Full Name",
    Footer: "fullName",
    accessor: row => `${row.firstName} ${row.lastName}`,
    id: "fullName",
  },
  {
    Header: "Passport No.",
    Footer: "",
    accessor: row => row.Passports?.[0]?.passportNo || "—",
    id: "passportNo",
    disableFilters: true,
  },
  {
    Header: "Email",
    Footer: "",
    accessor: "email",
  },
  {
    Header: "Nationality",
    Footer: "nationality",
    accessor: "nationality",
  },
  {
    Header: "Mobile",
    Footer: "",
    accessor: "mobile",
  },
  {
    Header: "Visa Expiry Date",
    Footer: "",
    accessor: row => row.Visas?.[0]?.expiryDate || null,
    id: "visaExpiryDate",
    disableFilters: true,
    Cell: ({ value }) => {
      if (!value) return <span className="text-gray-400">—</span>;
      const date = new Date(value);
      const isExpired = date < new Date();
      return (
        <span className={isExpired ? "text-red-600 font-semibold" : "text-green-700"}>
          {date.toLocaleDateString()}
        </span>
      );
    },
  },
  {
    Header: "Profile Status",
    Footer: "status",
    accessor: "status",
    Cell: ({ value, row }) => (
      <div className="flex items-center justify-center gap-2">
        <button
          onClick={() => handleStatusToggle(row.original)}
          className="flex items-center gap-2.5 focus:outline-none"
        >
          <span
            className={`relative inline-block w-12 h-6 rounded-full transition-colors duration-300 cursor-pointer flex-shrink-0 ${
              value === "Active" ? "bg-green-400" : "bg-gray-300"
            } hover:shadow-md`}
          >
            <span
              className={`absolute left-0.5 top-0.5 w-5 h-5 rounded-full shadow transition-transform duration-300 bg-white border ${
                value === "Active" ? "translate-x-6 border-green-500" : "translate-x-0 border-gray-400"
              }`}
            />
          </span>
          <span className={`text-sm font-semibold ${value === "Active" ? "text-green-700" : "text-gray-500"}`}>
            {value === "Active" ? "Active" : "Inactive"}
          </span>
        </button>
      </div>
    ),
  },
];
